module.exports = {
  title: 'Split Button with Reanimated and Gesture Handler 🪀',
  author: 'Enzo Manuel Mangano',
  date: '2023-09-06',
  slug: 'split-button',
  tags: ['reanimated', 'gesture-handler'],
};
